import { MyWishlistEmptyBox } from '@/components/content/Header/parts/MyWishlist/EmptyBox';
import { MyWishlistList } from '@/components/content/Header/parts/MyWishlist/List';
import {
	headerLoginRegisterPanelMenuCustomSX,
	loginRegisterPanelCloseIconXS,
	loginRegisterPanelTitleBoxSX,
	loginRegisterPanelTitleSX,
} from '@/components/content/Header/styles/login/loginRegisterPanel';
import { panelStyles } from '@/components/content/Header/styles/myWishList';
import {
	getLatestChanges,
	getPurchasedProducts,
} from '@/components/content/Header/utils/myWishlist';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useRecentOrders } from '@/data/Content/HdmRecentOrders';
import { useProducts } from '@/data/Content/Products';
import { useWishLists } from '@/data/Content/WishLists';
import { useLocalization } from '@/data/Localization';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Dispatch, FC, SetStateAction, useMemo } from 'react';
import {
	MATERIAL_SYMBOL_ICONS,
	OpenSansFontWeights,
} from 'shared/custom/constants/commonConstants';

type Props = {
	setOpenPanel: Dispatch<SetStateAction<boolean>>;
};

export const MyWishlistDropMenuPanel: FC<Props> = ({ setOpenPanel }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
	const panelLabels = useLocalization('SignInRegisterPanel');
	const icon = isMobile ? MATERIAL_SYMBOL_ICONS.wishlist : '';

	const { wishLists } = useWishLists();

	const { recentItems, partNumbers } = useMemo(() => {
		const recentItems = getLatestChanges(wishLists || []);

		return {
			recentItems,
			partNumbers: recentItems.map((item) => item.partNumber),
		};
	}, [wishLists]);

	const hasPartNumbers = partNumbers.length > 0;

	const { products } = useProducts({
		id: partNumbers,
		condition: hasPartNumbers,
		excludeProducts: false,
	});

	const { data: orderList } = useRecentOrders('D,S,SE,ER');

	const purchasedProducts = useMemo(() => {
		if (!orderList?.Order || !orderList?.OrderItems) return [];

		return getPurchasedProducts(orderList.Order, orderList.OrderItems, partNumbers);
	}, [orderList, partNumbers]);

	return (
		<Stack sx={headerLoginRegisterPanelMenuCustomSX(theme)}>
			<Box sx={loginRegisterPanelTitleBoxSX}>
				{isMobile && icon ? (
					<Box component="span" sx={panelStyles.mobileIcon}>
						<DynamicIcon name={icon} variant="filled" color={theme.palette.primary.main} />
					</Box>
				) : null}
				<Typography
					variant="headingSegment"
					component="span"
					fontWeight={OpenSansFontWeights.light}
					sx={loginRegisterPanelTitleSX}
				>
					{panelLabels.Titles.MyWishlist.t()}
				</Typography>
				{isMobile ? (
					<CloseIcon
						onClick={() => setOpenPanel(false)}
						sx={loginRegisterPanelCloseIconXS}
						className="wishlist__close"
					/>
				) : null}
			</Box>
			<Divider />
			<Box id="recentlySavedPanel">
				{recentItems.length > 0 ? (
					<MyWishlistList
						products={products}
						recentItems={recentItems}
						purchasedProducts={purchasedProducts}
					/>
				) : (
					<MyWishlistEmptyBox />
				)}
			</Box>
		</Stack>
	);
};
